export const VIDEO_WIDTH = 854;
export const VIDEO_HEIGHT = 480;
export const FRAME_RATE = 30;
//# sourceMappingURL=constants.js.map